<template lang="pug">
  div(ref="rootRef")
    slot
</template>

<script>
import { onMounted, ref, h } from '@vue/composition-api'

export default {
  setup (_, { emit, slots }) {
    const rootRef = ref()
    onMounted(
      () => {
        const root = rootRef.value
        emit(`input`, root.offsetHeight)
      }
    )
    return {
      rootRef
    }
  }
}
</script>
